import React from 'react';
import { 
  Mail, 
  Phone, 
  MapPin, 
  Facebook, 
  Twitter, 
  Instagram, 
  Linkedin, 
  Youtube,
  ArrowUp,
  Heart
} from 'lucide-react';

import img1 from '../components/images/logo.jpg'

export default function ModernFooter() {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const quick=[
    {
      name:"Home",
      link:"/"
    },
    {
      name:"About us",
      link:'/aboutus'
    },
    {
      name:"Contact us",
      link:"/contactus"
    },
    {
      name:"Services",
      link:"/services"
    }
  ];

  const services=[
    {
      name:"Coding Printers",
      link:"/LT"
    },
    {
      name:"Weighing Scales",
      link:"/"
    },
    {
      name:"EAS systems",
      link:"/"
    },
    {
      name:"Electronic Shelf Labels",
      link:"/"
    },
    {
      name:"POS systems",
      link:"/"
    },
    {
      name:"Tags and Labels",
      link:"/"
    }
  ]

  return (
    <footer className="relative bg-gradient-to-br from-black via-gray-900 to-gray-800 text-white overflow-hidden">
      {/* Animated background elements */}
      <div className="absolute inset-0 opacity-20">
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-gray-600 rounded-full mix-blend-multiply filter blur-xl animate-pulse"></div>
        <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-gray-700 rounded-full mix-blend-multiply filter blur-xl animate-pulse animation-delay-2000"></div>
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-slate-600 rounded-full mix-blend-multiply filter blur-xl animate-pulse animation-delay-4000"></div>
      </div>

      <div className="relative z-10 font-poppins">
        {/* Main Footer Content */}
        <div className="max-w-7xl mx-auto px-6 pt-16 pb-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            
            {/* Brand Section */}
            <div className="lg:col-span-1">
              <div className="mb-6">
                {/* Logo placeholder - you can uncomment and add your logo */}
                <div className="w-24 h-12 rounded mb-4 flex items-center justify-center">
                  <span className="">
                    <img src={img1}></img>
                  </span>
                </div>
                <p className="text-gray-300 mt-4 leading-relaxed">
                  Creating exceptional digital experiences that inspire and engage. We're passionate about innovation and excellence.
                </p>
              </div>
              
              {/* Social Links */}
              <div className="flex space-x-4">
                {[Facebook, Twitter, Instagram, Linkedin, Youtube].map((Icon, index) => (
                  <button
                    key={index}
                    className="w-10 h-10 bg-white/10 backdrop-blur-sm rounded-full flex items-center justify-center hover:bg-gradient-to-r hover:from-gray-600 hover:to-gray-800 transition-all duration-300 transform hover:scale-110 hover:shadow-lg"
                  >
                    <Icon size={18} />
                  </button>
                ))}
              </div>
            </div>

            {/* Quick Links */}
            <div>
              <h4 className="text-xl font-semibold mb-6 relative">
                Quick Links
                <div className="absolute bottom-0 left-0 w-12 h-0.5 bg-gradient-to-r from-gray-400 to-gray-600"></div>
              </h4>
              <ul className="space-y-3">
                {quick.map((link, index) => (
                  <li key={index}>
                    <a href={link.link} className="text-gray-300 hover:text-white hover:translate-x-2 transition-all duration-300 inline-block">
                      {link.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            {/* Services */}
            <div>
              <h4 className="text-xl font-semibold mb-6 relative">
                Services
                <div className="absolute bottom-0 left-0 w-12 h-0.5 bg-gradient-to-r from-gray-400 to-gray-600"></div>
              </h4>
              <ul className="space-y-3">
                {services.map((service, index) => (
                  <li key={index}>
                    <a href="#" className="text-gray-300 hover:text-white hover:translate-x-2 transition-all duration-300 inline-block">
                      {service.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            {/* Contact Info */}
            <div>
              <h4 className="text-xl font-semibold mb-6 relative">
                Get in Touch
                <div className="absolute bottom-0 left-0 w-12 h-0.5 bg-gradient-to-r from-gray-400 to-gray-600"></div>
              </h4>
              <div className="space-y-4">
                <div className="flex items-center space-x-3 group">
                  <div className="w-8 h-8 bg-gradient-to-r from-gray-600 to-gray-800 rounded-full flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                    <Mail size={14} />
                  </div>
                  <span className="text-gray-300 group-hover:text-white transition-colors duration-300">
                    sales@tsgce-sa.com
                  </span>
                </div>
                <div className="flex items-center space-x-3 group">
                  <div className="w-8 h-8 bg-gradient-to-r from-gray-600 to-gray-800 rounded-full flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                    <Phone size={14} />
                  </div>
                  <span className="text-gray-300 group-hover:text-white transition-colors duration-300">
                    +966 506976016
                  </span>
                </div>
                <div className="flex items-center space-x-3 group">
                  <div className="w-8 h-8 bg-gradient-to-r from-gray-600 to-gray-800 rounded-full flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                    <MapPin size={14} />
                  </div>
                  <span className="text-gray-300 group-hover:text-white transition-colors duration-300">
                    Al-khobar - 31952, <br/>Kingdom of Saudi Arabia
                  </span>
                </div>
              </div>
            </div>
          </div>

          {/* Newsletter Signup */}
          <div className="mt-12 pt-8 border-t border-white/10">
            <div className="max-w-lg mx-auto text-center">
              <h4 className="text-xl font-semibold mb-4">Stay Updated</h4>
              <p className="text-gray-300 mb-6">Subscribe to our newsletter for the latest updates and insights.</p>
              <div className="flex gap-2">
                <input
                  type="email"
                  placeholder="Enter your email"
                  className="flex-1 px-4 py-3 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-gray-400 focus:border-transparent transition-all duration-300"
                />
                <button className="px-6 py-3 bg-gradient-to-r from-gray-600 to-gray-800 rounded-full font-semibold hover:shadow-lg hover:scale-105 transition-all duration-300">
                  Subscribe
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="border-t border-white/10 bg-black/30 backdrop-blur-sm">
          <div className="max-w-7xl mx-auto px-6 py-6">
            <div className="flex flex-col md:flex-row items-center justify-between">
              <div className="flex items-center space-x-2 text-gray-300 mb-4 md:mb-0">
                <span>&copy; 2024 Thirdstep. Made with</span>
                <Heart size={16} className="text-red-400 animate-pulse" />
                <span>All rights reserved.</span>
              </div>
              
              <div className="flex items-center space-x-6">
                <a href="#" className="text-gray-300 hover:text-white transition-colors duration-300">Privacy Policy</a>
                <a href="#" className="text-gray-300 hover:text-white transition-colors duration-300">Terms of Service</a>
                
                {/* Back to Top Button */}
                <button
                  onClick={scrollToTop}
                  className="w-10 h-10 bg-gradient-to-r from-gray-600 to-gray-800 rounded-full flex items-center justify-center hover:shadow-lg hover:scale-110 transition-all duration-300"
                  aria-label="Back to top"
                >
                  <ArrowUp size={18} />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}